// src/firebase.js

import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// ✅ Firebase configuration (FROM FIREBASE CONSOLE)
const firebaseConfig = {
  apiKey: "AIzaSyD4VY5GiOwBGJ3k3oxbziO-VyjJIEfyh1w",
  authDomain: "delivery-app-84c5f.firebaseapp.com",
  projectId: "delivery-app-84c5f",
  storageBucket: "delivery-app-84c5f.appspot.com",
  messagingSenderId: "606133608872",
  appId: "1:606133608872:web:104d6075fe2b18ab6fbd9d",
};

// 🔥 Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// 🔔 Firebase Cloud Messaging
const messaging = getMessaging(firebaseApp);

// ✅ EXPORTS
export { firebaseApp, messaging };
